import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ImageService } from '@app/_services/image.service';
import { faPlusCircle, faSearch, faCircleArrowRight, faCircleArrowLeft, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
//import { ImageSnippet } from '@app/_models/image.snippet.model';


class ImageSnippet {
  pending: boolean = false;
  status: string = 'init';

  constructor(public src: string, public file: File) {}
}

@Component({
    selector: 'app-visitor',
    templateUrl: './visitor.component.html',
    styleUrls: ['./visitor.component.css'],
    standalone: false
})
export class VisitorComponent {

  faPlusCircle = faPlusCircle;
  faSearch = faSearch;
  faCircleArrowRight = faCircleArrowRight;
  faCircleArrowLeft = faCircleArrowLeft;
  faPaperPlane = faPaperPlane;


  action: any;

  searchVisitor: any;

  help = false;
  submitUpdate = false;
  submitAdd = false;

  uploadProgress = 0;

  constructor(private formBuilder: FormBuilder, 
    private router: Router, private toastr: ToastrService,
    private route: ActivatedRoute,
    private imageService: ImageService) { }

  addVisitorForm!: FormGroup;
  editVisitorForm!: FormGroup;

  fileName= '';

  numberPattern = '[0-9]*';

  ngOnInit(): void {

    this.route.params.subscribe((params: Params) => this.action = params['action']);

    this.addVisitorForm= this.formBuilder.group({
      id: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      guestId: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', Validators.required],
      propertyId: ['', Validators.required],
      createdBy: ['', Validators.required],
      startDtime: ['', Validators.required],
      stopDtime: ['', Validators.required],
    });

    this.editVisitorForm = this.formBuilder.group({
      id: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      guestId: ['', [Validators.required, Validators.minLength(10)]],
      email: ['', Validators.required],
      propertyId: ['', Validators.required],
      createdBy: ['', Validators.required],
      startDtime: ['', Validators.required],
      stopDtime: ['', Validators.required],
      approver1: ['', Validators.required],
      approver1Dtime: ['', Validators.required],
      approver2: ['', Validators.required],
      approver2Dtime: ['', Validators.required],
    });

  }

  
  get fi() { return this.addVisitorForm.controls; }
  get fe() { return this.editVisitorForm.controls; }

  selectedFile!: ImageSnippet;

  private onSuccess() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'ok';
  }

  private onError() {
    this.selectedFile.pending = false;
    this.selectedFile.status = 'fail';
    this.selectedFile.src = '';
  }

  processFile(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedFile = new ImageSnippet(event.target.result, file);

      this.selectedFile.pending = true;
      this.imageService.uploadImage(this.selectedFile.file).subscribe(
        (res) => {
          this.onSuccess();
        },
        (err) => {
          this.onError();
        })
    });

    reader.readAsDataURL(file);
  }

  addVisitor() {
    this.router.navigate(['/visitor/create']);
  }

  onSubmit() {
    console.log('Submit clicked');
    console.log(this.addVisitorForm.value);
  }

  selectedIndex = 0;
  maxNumberOfTabs = 3;

  onContinue(event: any) {
    if (this.selectedIndex != this.maxNumberOfTabs) {
      this.selectedIndex = this.selectedIndex + 1;
    }
    console.log(this.selectedIndex);
    alert('button pressed');
    //console.log(this.addVisitorForm.value);
  }

  next(event: any) {
    if (this.selectedIndex != this.maxNumberOfTabs) {
      this.selectedIndex = this.selectedIndex + 1;
    }
    console.log('Did this work', this.selectedIndex);
  }

  previous(event: any) {
    if (this.selectedIndex >= 1) {
      this.selectedIndex = this.selectedIndex - 1;
    }
    console.log(this.selectedIndex);
  }


  cancelUpload() {
    this.fileName = '';
  }

  onFileSelected(event: any) {

    const file:File = event.target.files[0];

    if (file) {

        this.fileName = file.name;

        const formData = new FormData();

        formData.append("thumbnail", file);

        //const upload$ = this.http.post("/api/thumbnail-upload", formData);


        //upload$.subscribe();

    }

}


}
